import { crudController } from 'fc-controller'

import {
  URL,
  MODEL,
  TREE,
  BRANCH,
} from 'fc-model-sampling-jobs'

// Selectors
import token$ from 'fc-auth/src/selectors/token'

import { composeFetchSaga } from 'fc-fetch-worker'

import worker from 'fc-wrkr-sampling-jobs'

// Controller
export default crudController({
  url: URL,
  model: MODEL,
  tree: TREE,
  branch: BRANCH,
  token$,
  initialize: function initialize (controller) {
    const terminate = function terminate () {
      if (worker) {
        console.warn('Terminating Sampling Jobs Worker')
        worker.terminate()
      }
    }

    return new Promise((resolve) => {
      terminate()

      console.warn('Initializing Sampling Jobs Worker')
      resolve({
        terminate,
        handleFetch: composeFetchSaga({
          getWorker: function (): Worker {
            return worker.getWorker()
          },
        }),
      })
    })
  },
})
